let requisicaoFuncoes = 0;

function sincronizarTextoFuncao() {
    const select = document.getElementById('funcao-select');
    document.querySelector('#funcao-text span').textContent = select.options[select.selectedIndex]?.text || 'Selecione...';
}

function atualizarOutraFuncao() {
    const outra = document.getElementById('funcao-select').value === 'outra';
    const input = document.getElementById('funcao-outra-input');
    document.getElementById('funcao-outra-container').style.display = outra ? 'block' : 'none';
    input.required = outra;
    input.disabled = !outra;
    if (!outra) {
        input.value = '';
    }
}

function carregarFuncoes(relacao) {
    const funcaoSelect = document.getElementById('funcao-select');
    const requisicao = ++requisicaoFuncoes;
    funcaoSelect.innerHTML = '<option value="">Carregando...</option>';
    // O select vazio continua obrigatorio para impedir envio durante o carregamento.
    funcaoSelect.disabled = false;
    funcaoSelect.required = true;
    sincronizarTextoFuncao();
    atualizarOutraFuncao();

    fetch('inscricao/funcoes/' + encodeURIComponent(relacao))
        .then(response => {
            if (!response.ok) {
                throw new Error('Falha ao carregar as opcoes');
            }
            return response.text();
        })
        .then(html => {
            // Uma resposta antiga nao pode sobrescrever as opcoes do tipo atual.
            if (requisicao !== requisicaoFuncoes) {
                return;
            }
            funcaoSelect.innerHTML = html;
            funcaoSelect.value = '';
            sincronizarTextoFuncao();
        })
        .catch(error => {
            if (requisicao !== requisicaoFuncoes) {
                return;
            }
            console.error('Erro ao carregar funcoes:', error);
            funcaoSelect.innerHTML = '<option value="">Erro ao carregar. Selecione o tipo novamente.</option>';
            sincronizarTextoFuncao();
        });
}

function aplicarRelacaoCoop(relacao, recarregar = true) {
    document.querySelector('.form-hide').style.display = relacao ? 'block' : 'none';
    document.querySelectorAll('.sh-field').forEach(campo => {
        const ativo = campo.classList.contains(relacao);
        campo.style.display = ativo ? 'block' : 'none';
        campo.querySelectorAll('input, select, textarea').forEach(input => {
            input.required = ativo;
            input.disabled = !ativo;
        });
    });
    document.querySelectorAll('.sh-label').forEach(label => {
        label.style.display = label.classList.contains(relacao) ? 'block' : 'none';
    });
    const funcaoSelect = document.getElementById('funcao-select');
    funcaoSelect.required = Boolean(relacao);
    funcaoSelect.disabled = !relacao;
    if (recarregar && relacao) {
        carregarFuncoes(relacao);
    } else {
        sincronizarTextoFuncao();
        atualizarOutraFuncao();
    }
}

function initRelacaoCoop() {
    const funcaoSelect = document.getElementById('funcao-select');
    if (!funcaoSelect) {
        return;
    }
    document.querySelectorAll('input[name="Inscricao[relacao_coop]"]').forEach(radio => {
        radio.addEventListener('change', function() {
            if (this.checked) {
                aplicarRelacaoCoop(this.value);
            }
        });
    });
    funcaoSelect.addEventListener('change', () => {
        sincronizarTextoFuncao();
        atualizarOutraFuncao();
    });
    const selecionado = document.querySelector('input[name="Inscricao[relacao_coop]"]:checked');
    // Preserva os dados renderizados pelo servidor depois de um erro de validacao.
    aplicarRelacaoCoop(selecionado ? selecionado.value : '', false);
}

document.addEventListener('DOMContentLoaded', initRelacaoCoop);

/**
 * Loads the cities <option> list for the selected UF into .cidade, via the extranet's
 * SiteController::cidades action.
 * @param {HTMLSelectElement} estadoSelect The UF <select> that changed.
 * @returns {void}
 */
function carregarCidades(estadoSelect) {
    const box = estadoSelect.closest('.uf-city'),
        cidadeSelect = box.querySelector('.cidade'),
        textSpan = box.querySelector('#city-text span');

    cidadeSelect.innerHTML = '<option value="">Carregando...</option>';
    textSpan.textContent = 'Carregando...';

    fetch('extranet/site/cidades?uf=' + encodeURIComponent(estadoSelect.value))
        .then(response => response.json())
        .then(data => {
            cidadeSelect.innerHTML = '<option value="">Cidade...</option>';
            textSpan.textContent = 'Cidade';

            Object.keys(data).forEach(key => {
                const val = data[key];
                if (val) {
                    const option = document.createElement('option');
                    option.value = key;
                    option.textContent = val;
                    cidadeSelect.appendChild(option);
                }
            });
        });
}

document.querySelectorAll('.estado').forEach(estadoSelect => {
    estadoSelect.addEventListener('change', event => carregarCidades(event.target));
});
